$(function () {
    // Verifica hash ao iniciar
    URI.init();

    if (localStorage.getItem('avaliacao') === null) {
        $('#aval-modal').modal('show');
    }

    $('#aval-telefone').mask('(00) 00000-0000');

    // let notshowAvaliacao = $("input[id='aval-notshow']:checked");

    $('#aval-modal-send').off('click');
    $('#aval-modal-send').on('click', function () {
        $('#aval-rodovia-form').each(function () {});
        let notarodovia = $("#aval-rodovia-form input[type='radio']:checked").val();
        let descricaorodovia = $('#aval-rodovia-form #aval-descricao').val();

        let notaadministracao = $("#aval-administracao-form input[type='radio']:checked").val();
        let descricaoadministracao = $('#aval-administracao-form #aval-descricao').val();

        let notacolaboradores = $("#aval-colaboradores-form input[type='radio']:checked").val();
        let descricaocolaboradores = $('#aval-colaboradores-form #aval-descricao').val();

        let notapedagio = $("#aval-pedagio-form input[type='radio']:checked").val();
        let descricaopedagio = $('#aval-pedagio-form #aval-descricao').val();

        let notshow = $('#aval-notshow').is(':checked');
        let descricaooutro = $('#aval-outro-descricao').val();
        let nome = $('#aval-nome').val();
        let telefone = $('#aval-telefone').val();
        let email = $('#aval-email').val();

        let data = {
            action: 'avaliacoes/insert',
            notarodovia: notarodovia,
            descricaorodovia: descricaorodovia,
            notaadministracao: notaadministracao,
            descricaoadministracao: descricaoadministracao,
            notacolaboradores: notacolaboradores,
            descricaocolaboradores: descricaocolaboradores,
            notapedagio: notapedagio,
            descricaopedagio: descricaopedagio,
            notshow: notshow,
            notarodovia: notarodovia,
            nome: nome,
            email: email,
            telefone: telefone,
            descricaooutro: descricaooutro,
        };
        $.post('/load/acmanager', data, function (r) {
            let response = $.parseJSON(r);
            if (response.response) {
                $('#aval-modal-send').prop('disabled', true);
                $('#aval-form').addClass('d-none');
                $('#aval-success').removeClass('d-none');
                $('#aval-success').html(response.msg);
                localStorage.setItem('avaliacao', true);
                setTimeout(function () {
                    $('#aval-modal').modal('hide');
                }, 2200);
            } else {
                if (!notshow) {
                    $('#aval-error').removeClass('d-none');
                    $('#aval-error').fadeIn('fast');
                    $('#aval-error').html(response.msg);
                    setTimeout(function () {
                        $('#aval-error').fadeOut('fast');
                    }, 3000);
                } else {
                    localStorage.setItem('avaliacao', true);
                    $('#aval-modal').modal('hide');
                }
            }
        });
    });

    $('#dropdown-rodovias').popover({ trigger: 'hover', html: true });

    $(window).click(function () {
        $('.menu-mobile-container').removeClass('open');
    });

    $('.menu-mob-bars').click(function (e) {
        e.stopPropagation();
        if ($('.menu-mobile-container').hasClass('open')) {
            $('.menu-mobile-container').removeClass('open');
        } else {
            $('.menu-mobile-container').addClass('open');
        }

        return false;
    });

    $('.disabled-logo').click(function () {
        window.location = '/change';
    });

    $('#btn-nfc').click(function () {
        window.location = '/cupom/index/chave/' + $('#chave-nfc').val();
    });

    $('#chave-nfc').keypress(function (e) {
        if (e.keyCode == 13) {
            $('#btn-nfc').click();
        }
    });
});
